import React from "react";
import KeywordsTag from './KeywordsTag';

const Iceland = ({ yearsIsVisible, monthsIsVisible, keywordsIsVisible }) => (
    <KeywordsTag
        tagId="icelandpublic"
        handwritingSrc="../../content/handwriting/iceland.png"
        handwritingAlt="iceland"
        yearsIsVisible={yearsIsVisible}
        monthsIsVisible={monthsIsVisible}
        keywordsIsVisible={keywordsIsVisible}
    />
);

export default Iceland;